@let productData = product();

<mat-card>
  <mat-card-content>
    @if (productData.images.length > 0) {
      <div class="product-image-and-labels">
        @if (showProductLabels()) {
          <ui-product-labels
            [groups]="['product-icons']"
            [product]="productData">
          </ui-product-labels>
        }
        <ui-image-gallery [images]="productData.images" [overlayReferenceElement]="productDetailData"></ui-image-gallery>
      </div>
    }

    <div class="product-info">
      <div class="product-title">
        @if (productData.details.name; as name) {
          <h5 class="product-name">{{ name }}</h5>
        }

        @if (productData.details.manufacturer; as manufacturer) {
          <span class="manufacturer">{{ manufacturer }}</span>
        }
      </div>

      @if (showProductLabels()) {
        <ui-product-labels
          [groups]="['product-badges']"
          [product]="productData">
        </ui-product-labels>
      }

      <div #productDetailData>
        <ui-product-detail-data
          [scrollElement]="detailsDataScrollElement()"
          [product]="productData"
          [showProductInformationOnly]="showProductInformationOnly()"
        ></ui-product-detail-data>
      </div>
    </div>
  </mat-card-content>
</mat-card>
